import { useState, useEffect } from 'react'
import AuthService from 'services/auth'
import cutileiApi from 'services/cutileiApi'
import { logApiError } from 'services/apiError'
import AdminNavbar from 'components/Navbars/AdminNavbar'
import MemberList from 'components/Lists/MemberList'
import TextInput from 'components/Inputs/TextInput'
import DateInput from 'components/Inputs/DateInput'
import Select from 'components/Inputs/Select'
import { ReactComponent as Loading } from 'icons/loading2.svg'

import {
  Container,
  TabRow,
  TabButton,
  FilterContainer
} from './styles'

export default function Members () {
  const [loading, setLoading] = useState (true)
  const [status, setStatus] = useState (
    localStorage.getItem ('member_status') || 'active'
  )
  const [query, setQuery] = useState ('')
  const [cancelReason, setCancelReason] = useState (null)
  const [page, setPage] = useState (1)
  const [lastPage, setLastPage] = useState (0)
  const [total, setTotal] = useState (0)
  const [members, setMembers] = useState ([])
  const [dateRange, setDateRange] = useState ([null, null])
  const token = AuthService.getToken ()

  const requestConfig = {
    headers: {
      'Authorization': `Bearer ${token}`
    }
  }

  const STATUS_LIST = [
    {label: 'Ativos', value: 'active', color: '#44CF6C'},
    {label: 'Inadimplentes', value: 'overdue', color: '#FFC100'},
    {label: 'Cancelados', value: 'canceled', color: '#FF3939'},
    {label: 'Bloqueados', value: 'blocked', color: '#252525'},
    {label: 'Leads', value: 'leads', color: '#35A7FF'}
  ]

  const CANCEL_OPTIONS = [
    {label: 'Motivo financeiro', value: 'Motivo financeiro'},
    {label: 'Disponibilidade de dias e horários', value: 'Disponibilidade de dias e horários'},
    {label: 'Atendimento dos salões', value: 'Atendimento dos salões'},
    {label: 'Ambiente dos salões', value: 'Ambiente dos salões'},
    {label: 'Atendimento dos profissionais', value: 'Atendimento dos profissionais'},
    {label: 'Serviço realizado', value: 'Serviço realizado'},
    {label: 'Outro', value: 'Outro'}
  ]

  useEffect (() => {
    getMembers (status, query, 1)
  }, [status, query, cancelReason, dateRange])

  const getMembers = async (selectedStatus = status, nameQuery = query, pageNumber = page) => {
    if (lastPage && pageNumber > lastPage) return
    const startDate = dateRange ? dateRange[0] : null
    const endDate = dateRange ? dateRange[1] : null

    try {
      if (pageNumber === 1) setLoading (true)
      if (selectedStatus === 'leads') {
        let filters = `page=${pageNumber}&query=${encodeURIComponent (nameQuery)}`

        if (startDate && endDate)
          filters += `&start_date=${startDate}&end_date=${endDate}`

        const { data: leadsReponse } = await cutileiApi.get (`/leads?${filters}`, requestConfig)

        const { data, meta } = leadsReponse
        const leadsData = pageNumber > 1 ? [...members, ...data] : data
        
        setMembers (leadsData)
        setPage (pageNumber + 1)
        setLastPage (meta.last_page)
        setTotal (meta.total)
      } else {
        let filters = `page=${pageNumber}&query=${encodeURIComponent (nameQuery)}&status=${selectedStatus}`

        if (selectedStatus === 'canceled' && cancelReason)
          filters += `&cancel_reason=${cancelReason.value}`

        if (startDate && endDate) {

          if (selectedStatus === 'canceled')
            filters += `&cancel_start=${startDate}&cancel_end=${endDate}`
          else
            filters += `&start_date=${startDate}&end_date=${endDate}`
        }

        const { data: membersResponse } = await cutileiApi.get (`/members?${filters}`, requestConfig)
        const { data, meta } = membersResponse
        const membersData = pageNumber > 1 ? [...members, ...data] : data

        setMembers (membersData)
        setPage (pageNumber + 1)
        setLastPage (meta.last_page)
        setTotal (meta.total)
      }
    } catch (error) {
      logApiError (error)
    } finally {
      setLoading (false)
    }
  }

  return (
    <Container>
      <AdminNavbar/>
      <TabRow>
        {STATUS_LIST.map (s =>
          <TabButton
            key={s.value}
            selected={status === s.value}
            color={s.color}
            onClick={() => {
              setStatus (s.value)
              localStorage.setItem ('member_status', s.value)
            }}
          >
            {s.label}
          </TabButton>
        )}
      </TabRow>
      {(status === 'canceled' || status === 'leads') && (
        <FilterContainer>
          <DateInput
            value={dateRange}
            placeholder='Selecionar período'
            selectRange={true}
            clearable={true}
            onChange={setDateRange}
            style={{ width: 280 }}
          />
        </FilterContainer>
      )}
      <FilterContainer>
        <TextInput
          value={query}
          placeholder='Pesquisar por nome'
          isClearable={true}
          onChange={e => setQuery (e.target.value)}
          onClear={() => setQuery ('')}
          containerStyle={{width: 280}}
          inputStyle={{boxShadow: '0px 1px 10px -6px', paddingInline: 12}}
        />
        {status === 'canceled' && (
          <Select
            name='cancel_reason'
            placeholder='Motivo de cancelamento...'
            value={cancelReason}
            options={CANCEL_OPTIONS}
            onChange={(_, option) => setCancelReason (option)}
            containerStyles={{width: 260}}
          />
        )}
      </FilterContainer>
      {loading ? <Loading style={{marginTop: 30}}/> : (
        <MemberList
          members={members}
          totalMembers={total}
          hasMore={!(lastPage && page > lastPage)}
          onUpdate={member => setMembers (members.map (m => m.id === member.id ? member : m))}
          onScroll={getMembers}
        />
      )}
    </Container>
  )
}
